/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Impero Org API
 * The Impero Backend's API for organizations, i.e. orgname.impero.com.
 */

/**
 * Which access rights of an entity a bulk access right change applies to.
 */
export type EntitiesAccessRightsUpdateScope =
    (typeof EntitiesAccessRightsUpdateScope)[keyof typeof EntitiesAccessRightsUpdateScope];

export const EntitiesAccessRightsUpdateScope = {
    control: "control",
    risk: "risk",
    both: "both",
} as const;
